import { render } from "./ContactCard.vue?vue&type=template&id=2ef5827c&ts=true"
import script from "./ContactCard.vue?vue&type=script&lang=ts"
export * from "./ContactCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__